import { Suspense } from 'react';
import { Loading } from '@app/components/common/Loading/Loading';

export const withLoading = (Component) => {
  return (props) => (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};
